<ng-container *ngIf="!sipConnectionOK || !microphoneStateOK || !chromeNotificationOK">
  <hr>
  <div class="error" *ngIf="!sipConnectionOK">
    {{ 'jsphone_status.connection_lost' | translate }} {{phoneErrorMessage()}}
  </div>
  <div class="error" *ngIf="!microphoneStateOK">
    {{ 'jsphone_status.no_mic_access' | translate }}
  </div>
  <div class="error" *ngIf="!chromeNotificationOK">
    {{ 'jsphone_status.blocked_notifications' | translate }}
  </div>
</ng-container>
